import { defineStore } from 'pinia'
import versionChecker from '../services/versionService'

const MIN_CHECK_INTERVAL = 5 * 60 * 1000 // 5 minutes in milliseconds

export const useVersionStore = defineStore('version', {
	state: () => ({
		currentVersion: '',
		lastCheckTime: 0,
		updatePostponed: false,
		showUpdateModal: false
	}),

	actions: {
		async checkVersion() {
			// Initialize current version if not set
			this.showUpdateModal = false

			if (!this.currentVersion) {
				console.log('[Version Check] Initializing current version')
				const { version } = await versionChecker.checkForUpdates(this.currentVersion)
				this.currentVersion = version
				this.showUpdateModal = false
				return false
			}

			// Check if enough time has passed since last check
			const now = Date.now()
			console.log('[Version Check] Last check time:', new Date(this.lastCheckTime).toLocaleString())

			const timeSinceLastCheck = now - this.lastCheckTime
			const timeRemaining = MIN_CHECK_INTERVAL - timeSinceLastCheck

			if (timeRemaining > 0) {
				const minutesRemaining = Math.ceil(timeRemaining / 60000)
				console.log(
					`[Version Check] Skipping - next check in ${minutesRemaining} minute${
						minutesRemaining > 1 ? 's' : ''
					}`
				)
				return false
			}

			// Update last check time first to prevent multiple checks
			this.lastCheckTime = now
			console.log('[Version Check] Setting last check time to', new Date(now).toLocaleString())

			const { hasUpdate, version } = await versionChecker.checkForUpdates(this.currentVersion)

			// Update version and show modal if there's an update
			if (hasUpdate && version) {
				console.log('[Version Check] New version detected - showing update modal')
				this.currentVersion = version
				this.showUpdateModal = true
				return true
			}

			return false
		},

		promptUpdate() {
			// Force reload to get new version
			window.location.reload()
		},

		postponeUpdate() {
			this.updatePostponed = true
			setTimeout(() => {
				this.updatePostponed = false
				this.checkVersion()
			}, 60 * 60 * 1000) // 1 hour
		}
	},

	persist: {
		key: 'version-store',
		paths: ['currentVersion', 'lastCheckTime'],
		afterRestore: (ctx) => {
			// Ensure we have valid values after restore
			if (!ctx.store.currentVersion) ctx.store.currentVersion = ''
			if (!ctx.store.lastCheckTime) ctx.store.lastCheckTime = 0
		}
	}
})
